// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import tripExpenseEntity from './entities/trip-expense.json';
import tripExpenseMenu from '../pages/trip-expense/menu.json';
import tripExpenseFullForm from '../pages/trip-expense/forms/full.json';
import tripExpenseContextForm from '../pages/trip-expense/forms/context.json';
import tripExpenseMiniForm from '../pages/trip-expense/forms/mini.json';
import tripExpenseLookupForm from '../pages/trip-expense/forms/lookup.json';
import tripExpenseTableView from '../pages/trip-expense/views/table.json';
import tripExpenseCardsView from '../pages/trip-expense/views/cards.json';
import tripExpenseDashboardView from '../pages/trip-expense/views/dashboard.json';

/** Тип запису «Витрата на поїздку» зі сторінками пакета: меню, форми та подання з pages/trip-expense/. */
export const tripExpenseDefinition: IRecordTypeDefinition = {
  ...tripExpenseEntity,
  views: assembleViewSet({
      table: tripExpenseTableView,
      cards: tripExpenseCardsView,
      dashboard: tripExpenseDashboardView,
  }),
  form: tripExpenseFullForm,
  forms: { full: tripExpenseFullForm, context: tripExpenseContextForm, mini: tripExpenseMiniForm, lookup: tripExpenseLookupForm },
  menu: tripExpenseMenu,
} as IRecordTypeDefinition;
